<template>
  <div class="video-program-detail-content-component">
    <div class="tab-content"
         v-if="render && render.content"
    >
      <ym-tabs v-model="tabSelected"
               size="medium"
      >
        <ym-tab v-if="render.content"
                name="material"
                :title="render.content.title"
        >
          <ym-content v-if="render.content.show"
                      :content="render.content.value"
                      show-padding
          />
          <empty-page v-else
                      class="empty-program-content"
                      type="lock"
                      hint="订阅后即可查看"
                      model="content"
          >
            <ym-button class="buy-btn"
                       type="primary"
                       round
                       plain
                       @click="handleClickJoin"
            >
              马上订阅
            </ym-button>
          </empty-page>
        </ym-tab>

        <ym-tab name="review">
          <template slot="title">
            评价
            <span class="num"
                  v-if="reviews.count > 0"
            >{{ reviews.count > 999 ? '999+' :  reviews.count  }}</span>
          </template>

          <review-list :reviews="reviews.list"
                       :next-start="reviews.start"
                       :target-id="programId"
                       target-type="program"
                       show-reply
                       @reply="handleClickReply"
          />
        </ym-tab>
      </ym-tabs>
    </div>
    <review-block v-else
                  :is-member="isMember"
                  :program-id="programId"
                  :reviews="reviews"
                  :show-create="isMember"
                  show-reply
                  @reply="handleClickReply"
                  @show-review="showReviewList"
    />
  </div>
</template>

<script>
  import { Tabs, Tab, Button } from '@ymba/ym-ui';
  import Content from '@/components/RichText';
  import ReviewList from '@/components/CommentList/List';
  import EmptyPage from '@/components/EmptyPage';
  import ReviewBlock from '@/pages/AudioProgram/components/AudioProgramReviewBlock';
  import validator from '@/utils/validator';

  export default {
    name: 'VideoProgramDetailContent',
    components: {
      'ym-tabs': Tabs,
      'ym-tab': Tab,
      'ym-button': Button,
      'ym-content': Content,
      ReviewList,
      ReviewBlock,
      EmptyPage,
    },
    data() {
      return {
        tabSelected: '',
      };
    },
    props: {
      programId: {
        type: Number,
        required: true,
      },
      reviews: {
        type: Object,
        required: true,
      },
      isMember: {
        type: Boolean,
        required: true,
      },
      render: {
        type: Object,
        validator(val) {
          return validator.isObject(val);
        },
      },
      tabActive: {
        type: String,
        required: true,
      },
    },
    watch: {
      tabActive(val) {
        this.tabSelected = val;
      },
      tabSelected(val) {
        this.$emit('update:tabActive', val);
      },
    },
    methods: {
      handleClickJoin() {
        this.$emit('click-join');
      },
      handleClickReply(data) {
        this.$emit('reply', data);
      },
      showReviewList() {
        if (!this.isMember) {
          this.$toast('订阅后即可参与评论');
          return;
        }
        const route = { name: 'ProgramReviewList', params: { id: this.programId } };
        this.$router.push(route);
      },
    },
    created() {
      this.tabSelected = this.tabActive;
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .video-program-detail-content-component {
    margin-top: @size-small;
  }

  .program-material {
    padding: @size-base;
    line-height: 1.4;
    font-size: @font-size-base;
    word-break: break-all;
    box-sizing: border-box;
    /deep/ p {
      margin: 0;
    }
    /deep/ img, /deep/ iframe {
      display: block;
      max-width: 100%;
    }
    /deep/ video {
      display: block;
      margin: 0 auto;
      width: 690px;
      height: 388px;
    }
  }

  .empty-program-content {
    padding: @size-large 0;
    .buy-btn {
      margin-top: @size-medium;
    }
  }
</style>
